export class AccountCreatedConstants {
     static readonly ACCOUNT_CREATED = $localize`:@@account-created.model-title.account-created:Account Created`;
     static readonly ACCOUNT_REQUESTED = $localize`:@@account-created.model-title.account-created:Account Requested`;
     static readonly AUTO_CLOSING_SECONDS = 8000 ;
}
